import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/ingreso/getIngresosTotales.php';

export default function getIngresosTotales({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}